import React, { Fragment } from 'react'
import { Text, Heading, View } from '../primitives'
import Card from '../Card'
import { Post } from 'react-axios'
import TranslationsWrapper from '../../../TranslationsWrapper'
import { elementId, proceedingQueryLength } from '../../config'
import { compose, withState } from 'recompose'
import LoadMore from '../LoadMore'

const replaceKeys = (source, keysToReplace) =>
    Object.keys(keysToReplace).reduce(
        (collect, key) => collect.replace(key, keysToReplace[key] || ''),
        source
    )

const Container = View.extend.attrs({ my: 3 })`
  min-height: 25vh;
`

const Item = View.extend.attrs({
    className: 'o-layout__item'
})``

const CountStatus = View.extend`
  text-align: right;
`

const ErrorView = View.extend.attrs({
    className: 'o-layout__item'
})`
  width: 100% !important;
`

const Button = Text.extend.attrs({
    className: 'c-btn'
})``

const ResultingVacancies = props => {
    const {
        API,
        queryData,
        favourites,
        toggleFavourite,
        translations,
        index,
        show: size,
        onChangeShow,
        disciplines,
        experiences,
        location,
        locationRegion,
        locationCountry,
        loadMore,
        updateCountStatus
    } = props
    return (
        <Fragment>
            <Post
                url={API}
                data={{ ...queryData, index, size: size }}
                debounce={500}
                debounceImmediate={true}
                onSuccess={response => {
                    updateCountStatus({
                        count: response.data.size > response.data.totalItems ?
                            response.data.totalItems : (response.data.index + response.data.size),
                        total: response.data.totalItems
                    })
                }}
            >
                {(error, response, isLoading, onReload) => {
                    if (error) {
                        return (
                            <ErrorView>
                                <Heading color="secondaryTextColor" fontSize={[3, 3, 3, 4]} my={1}>
                                    {translations['vacanciesError']} ({error.message}){' '}
                                </Heading>
                                <Button onClick={() => onReload({ params: { reload: true } })}>
                                    {translations['tryAgain']}
                                </Button>
                            </ErrorView>
                        )
                    } else if (response !== null) {
                        if (!response || !response.data.hasOwnProperty('vacancies')) {
                            return <ErrorView className="o-layout__item">
                                <Heading color="secondaryTextColor" fontSize={[3, 3, 3, 4]} my={1}>
                                    {translations['vacanciesError']}
                                </Heading>
                            </ErrorView>
                        }
                        if (response.data.totalItems < 1) {
                            return <ErrorView className="o-layout__item">
                                <Heading color="secondaryTextColor" fontSize={[4, 4, 4, 5]} my={1}>
                                    {translations['vacanciesNoResult']}
                                </Heading>
                            </ErrorView>
                        }
                        return (
                            <Fragment>
                                {response.data.vacancies.map((vacancy,i) => (
                                    <Item
                                        key={vacancy.vacancyId}
                                    >
                                        <Card
                                            id={vacancy.vacancyId}
                                            title={vacancy.title}
                                            disciplines={vacancy.disciplines}
                                            shortDescription={vacancy.shortDescription}
                                            favourites={favourites}
                                            toggleFavourite={toggleFavourite}
                                            educationLevels={vacancy.educationLevels}
                                            countryCode={vacancy.countryCode}
                                            location={vacancy.location}
                                            locationRegion={vacancy.locationRegion}
                                            locationCountry={vacancy.locationCountry}
                                            url={vacancy.url}
                                            highlighted={vacancy.highlighted}
                                        />
                                    </Item>
                                ))}

                                {false && (
                                    <button
                                        onClick={() => onReload({ params: { refresh: true } })}
                                    >
                                        Refresh
                  </button>
                                )}
                                {!props.loadMore && (
                                    <OpacityLoader opacity={isLoading ? 1 : 0}>
                                        {translations['loadingVacancies']}
                                    </OpacityLoader>
                                )}

                                {loadMore !== true &&
                                    response.data.index + response.data.size <
                                    response.data.totalItems && (
                                        <LoadMore
                                            translations={translations}
                                            size={Math.min(
                                                proceedingQueryLength,
                                                response.data.totalItems - size - index
                                            )}
                                            onClick={() => {
                                                props.pleaseDo(true)
                                                onChangeShow(
                                                    index +
                                                    size +
                                                    Math.min(
                                                        proceedingQueryLength,
                                                        response.data.totalItems - size - index
                                                    )
                                                )
                                            }}
                                        />
                                    )}

                                {loadMore && (
                                    <EnhancedResultingVacancies
                                        {...props}
                                        show={Math.min(
                                            proceedingQueryLength,
                                            response.data.totalItems - size - index
                                        )}
                                        index={index + size}
                                    />
                                )}
                            </Fragment>
                        )
                    }
                    if (size > 0) {
                        return (
                            <Fragment>
                                {[...Array(size)].map((vacancy, index) => (
                                    <Item key={index}>
                                        <Card id={index} loading />
                                    </Item>
                                ))}
                            </Fragment>
                        )
                    }
                    return <View /> // Default message before request is made -> never being shown since debounceImmediate=true
                }}
            </Post>
        </Fragment>
    )
}

const OpacityLoader = View.extend`
  transition: opacity 600ms ease;
  opacity: ${props => props.opacity};
`

const EnhancedResultingVacancies = withState('loadMore', 'pleaseDo', false)(
    ResultingVacancies
)

export default compose(
    withState('countStatus', 'updateCountStatus', {
        count: 0,
        total: 0
    }),
    TranslationsWrapper(elementId)
)(props => (
    <Container>
        <CountStatus>
            {'countOfTotal' in props.translations &&
                props.countStatus.total > 0 &&
                replaceKeys(props.translations['countOfTotal'], {
                    '{index}': `1`,
                    '{count}': `${props.countStatus.count}`,
                    '{total}': `${props.countStatus.total}`
                })}
        </CountStatus>
        <View className="o-layout o-layout--one-column">
            <View className="o-layout__item">
                <Container className="o-layout js-journal-component article-grid__hub">
                    <EnhancedResultingVacancies {...props} />
                </Container>
            </View>
        </View>
    </Container>
))
